import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { StaffService } from 'src/app/core/api/staff.service';
import { AttachmentsConfig, FormFieldConfig } from 'src/app/form-template/form-template-model';
import { BaseAttachmentsComponent } from 'src/app/shared/attachments/base-attachments';
import { FormTemplateGeneratorService } from '../../form-template-generator.service';
import { FormTemplateAttachmentsFieldService } from './form-template-attachments-field.service';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => FormTemplateAttachmentFieldGeneratorComponent),
  multi: true
};

@Component({
  selector: 'csi-form-template-attachment-field-generator',
  templateUrl: './form-template-attachment-field-generator.component.html',
  styleUrls: ['./form-template-attachment-field-generator.component.scss'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class FormTemplateAttachmentFieldGeneratorComponent extends BaseAttachmentsComponent
  implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: AttachmentsConfig };
  @Input() control: FormControl;
  @Input() formTemplateFieldKey: string;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  constructor(
    public formTemplateGeneratorService: FormTemplateGeneratorService,
    staffService: StaffService,
    protected injector: Injector,
    protected attachmentsService: FormTemplateAttachmentsFieldService
  ) {
    super(injector, staffService, attachmentsService);
  }

  ngOnInit() {
    this.metadata = this.baseAttachmentsService.generateMetadata(this.formTemplateFieldKey);
    this.formControl = this.control;
    super.ngOnInit(); // Must explicitly call super ngOnInit()
    this.maxAttachments = this.config.typeConfig.maxAttachments;
  }
}
